export const FINGERPRINTING_TIME_EVENT = 'Supplier_Basic_Fingerprint_Init_Time';
export const PWA_INIT_EVENT = 'Supplier_Basic_PWA_Initiation';
export const PWA_INSTALL_EVENT = 'Supplier_Basic_PWA_Install';
